module.exports = __webpack_public_path__ + "img/mt_shop_logo_hero.788878b0.png";